import { isFormula } from '../utils/dataUtils/formula/tableFormulaPredicateUtils';

// TODO: Once DraftJSFormulaAutocompleteHotPlugin has been removed,
//       we can inline these into FormulaAutocompleteHotPlugin

export type FormulaDropdownSession = {
    queryStartOffset: number;
    queryEndOffset: number;
};

export const createFormulaDropdownSession = (
    cellContent: string,
    queryStartOffset: number,
): FormulaDropdownSession | null =>
    isFormula(cellContent) ? { queryStartOffset, queryEndOffset: queryStartOffset } : null;
